<template>
  <div class="account-tab-item__group-item">
    <div class="account-tab-item__group-item-row _mod">
      <div class="account-tab-item__group-item-col">
        <div class="account-tab-item__label-mob">{{ $tAccount('Date') }}</div>
        <div class="account-tab-item__date">{{ item.created_at | formatDate }}</div>
      </div>
      <div class="account-tab-item__group-item-col">
        <div class="account-tab-item__label-mob">{{ $tAccount('Income') }}</div>
        <div v-if="item.type === INCOME_MY"
             class="status _yellow">
          {{ $tAccount('My income') }}
        </div>
        <div v-if="item.type  === INCOME_FROM_PARTNER"
             class="status _grey-dark">
          {{ $tAccount('From partner') }}
        </div>
      </div>
      <div class="account-tab-item__group-item-col">
        <div class="account-tab-item__label-mob">{{ $tAccount('Completed') }}</div>
        <div v-if="item.user_type === EMPLOYEE"
             class="status _green">
          {{ $tAccount('Employee') }}
        </div>
        <div v-if="item.user_type === EMPLOYER"
             class="status _aqua">
          {{ $tAccount('Partner') }}
        </div>
      </div>
    </div>
    <div class="account-tab-item__group-item-row">
      <div class="account-tab-item__operation-mob">
        <BaseSvg :name="item.source.icon"
                 class="account-tab-item__operation-mob-ico"/>
        <span>{{ item.source.name }}</span>

        <div v-if="item.source_customer_id"
             style="opacity: 0.75"
             class="account-tab-item__operation-mob-link">
          <span>{{ item.source_customer_id.fullname }}</span>&nbsp;
<!--          <BaseSvg name="ico-arrow-light" class="_arrow"/>-->
        </div>
      </div>
    </div>
    <div class="account-tab-item__group-item-row">
      <div v-if="item.partner" class="account-tab-item__user-small">
        <span class="account-tab-item__user-small-avatar"
              :style="{backgroundImage: `url(${item.partner.avatar})`}"></span>
        <div class="account-tab-item__user-small-content">
          <div class="account-tab-item__user-small-label">{{ $tAccount('Partner') }}</div>
          <div class="account-tab-item__user-small-name">
            {{ item.partner.fullname }}
          </div>
        </div>
      </div>

      <div class="account-tab-item__sum">
        + {{ item.summ | formatCurrency }} <span>JBN</span>
      </div>
    </div>
  </div>
</template>

<script>
  import {EMPLOYEE, EMPLOYER} from '@/constants/usersTypes'

  const INCOME_MY = 1
  const INCOME_FROM_PARTNER = 2

  export default {
    name: 'AccountTabItemHistoryRowMobile',
    props: {
      item: Object
    },
    data() {
      return {
        EMPLOYEE,
        EMPLOYER,

        INCOME_MY,
        INCOME_FROM_PARTNER,
      }
    },
  }
</script>

<style lang="less">

</style>